import React, { useState, useEffect, useRef } from "react";

import closeIcon from "../../../style/icons/CloseInBlueCircle/close.svg";
import shevronIcon from "../../../style/icons/ShevronDown/shevron-down.svg";
import doneIcon from "../../../style/icons/MarkDoneBlue/mark.svg";
// import undoneIcon from "../../../style/icons/MarkDoneBlue/undone.svg"; // Not strictly needed for single select display

import "./SingleSelectDropdown.scss"; // Import new SCSS file

const SingleSelectDropdown = ({ 
  disabled,
  options,      // Array of { id: any, title: string }
  onChange,     // Function called with selected option object (or null if cleared)
  placeholder,
  value,        // Single selected option object { id: any, title: string } (or null/undefined)
}) => {
  const [showOptions, setShowOptions] = useState(false);
  const [internalValue, setInternalValue] = useState(value);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const handleOptionClick = (option) => {
    setInternalValue(option);
    onChange(option); 
    setShowOptions(false);
  };

  const toggleDropdown = () => {
    if (!disabled) {
      setShowOptions(prev => !prev);
    }
  };

  const handleClearSelection = (e) => {
    e.stopPropagation(); // Prevent toggleDropdown from firing immediately after
    setInternalValue(null);
    onChange(null);
    setShowOptions(false);
  };

  const displayValue = internalValue ? internalValue.title : placeholder;
  const canClear = internalValue != null;

  return (
    <div className={`tagsInputContainer ${disabled ? "disabled" : ""}`} ref={dropdownRef}>
      <div className={`tagsInputField`} onClick={toggleDropdown}>
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {displayValue}
        </span>
        <div 
          className="iconToggle" 
          onClick={(e) => {
            if (canClear) {
              handleClearSelection(e); // handleClearSelection already has stopPropagation
            } else {
              e.stopPropagation(); // Prevent outer div's onClick
              toggleDropdown();     // Toggle the dropdown
            }
          }}
        >
          <img src={canClear ? closeIcon : shevronIcon} alt={canClear ? "Clear" : "Open"} />
        </div>
      </div>
      {showOptions && (
        <div
          className={`tagList active`} // Always active when showOptions is true
        >
          {options && options.length > 0 ? options.map((option) => (
            <div 
              key={option.id} 
              className="tag" 
              onClick={() => handleOptionClick(option)}
            >
              {option.title}
              {/* Show checkmark if this option is selected */}
              {internalValue && internalValue.id === option.id && (
                <img src={doneIcon} alt="Selected" />
              )}
            </div>
          )) : (
            <div className="tag" style={{ justifyContent: 'center', cursor: 'default' }}>No options available</div>
          )}
        </div>
      )}
    </div>
  );
};

export default SingleSelectDropdown; 